/* eslint-disable jsx-a11y/anchor-is-valid */

import { useTranslation } from "next-i18next";

export default function RemoveItem(props: any) {
  const { product, onRemove, showHelpText = false } = props;
  const { t } = useTranslation("shopping-cart");

  if (!onRemove) {
    return null;
  }

  return (
    <a
      href="#"
      className="d-flex align-items-center"
      onClick={(e) => {
        e.preventDefault();
        onRemove(product);
      }}
      data-testid="remove-cart-item"
    >
      <i className="fa fa-trash p-r-10" style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }} />
      {showHelpText ? t("Remove") : ""}
    </a>
  );
}
